module.exports = __webpack_public_path__ + "static/thai-aeb7fd9363f4e3ff82357048f5dac279.png";